/**
 * Statsig feature flag gate names.
 * Create the corresponding gate in the Statsig console to enable features.
 */
export const ATOMIC_ICB_ENABLED_GATE = "atomic-icb-enabled";

/** Step run list: Temporal workflow reset (replay) from a step. */
export const ATOMIC_STEP_RUN_REPLAY_ENABLED_GATE =
  "atomic-step-run-replay-enabled";

/** Process run retry: opt in to active deployment step config on manual retry. */
export const ATOMIC_RETRY_ACTIVE_DEFINITION_ENABLED_GATE =
  "atomic-retry-active-definition-enabled";

/** Process runs page: filter bar, URL state and query-API-driven dashboard. */
export const ATOMIC_RUNS_DASHBOARD_V2_GATE = "atomic-runs-dashboard-v2";
